---
import type { TypedObject, Props as $ } from "../lib/types";
import { getWarningMessage } from "../lib/warnings";

export type Props = $<TypedObject>;

const { node, isInline } = Astro.props;
const warning = getWarningMessage("type", node._type);
---

{
  isInline ? (
    <span style="display:none" data-portabletext-unknown="type">
      {warning}
    </span>
  ) : (
    <div style="display:none" data-portabletext-unknown="type">
      {warning}
    </div>
  )
}
